import { observer } from 'mobx-react-lite';
import { FC, useEffect, useMemo, useRef, useState } from 'react';

import { RoomCallPopupContent } from '@gem/call/components/RoomCallPopupContent/RoomCallPopupContent';
import { RoomCallPreviewVideo } from '@gem/call/components/RoomCallPreviewVideo/RoomCallPreviewVideo';
import { getMascotImageSrc } from '@gem/utils';

import Entities from 'STORE';

import { IRoomCallPreviewPopupPresenter } from '../RoomCallPreviewPopup.presenter';
import { StartCall } from '../StartCall/StartCall';
import styles from './CallDevicesPreview.styles.m.css';

interface ICallDevicesPreviewProps {
  presenter: IRoomCallPreviewPopupPresenter;
}

export const CallDevicesPreview: FC<ICallDevicesPreviewProps> = observer(({ presenter }) => {
  const onCallStartRef = useRef<() => Promise<void>>(null);
  const backgroundPanelRef = useRef<HTMLDivElement>(null);
  const [refState, setRefState] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    setRefState(backgroundPanelRef.current);
  }, [backgroundPanelRef]);

  const initialMedia = useMemo(() => {
    return {
      isVideoMuted: true,
      isAudioMuted: true,
    };
  }, []);

  return (
    <>
      <RoomCallPopupContent
        className={presenter.ongoingCall && styles.fixedContainer}
        lightImageName={getMascotImageSrc(PROJECT_CONFIG.imageAssets.previewLogoLight)}
        darkImageName={getMascotImageSrc(PROJECT_CONFIG.imageAssets.previewLogoDark)}
        applicationTheme={Entities.appearance.theme}
      >
        <div className={styles.content}>
          <RoomCallPreviewVideo
            onMediaPermissionsChanged={presenter.onMediaPermissionsChanged}
            backgroundPanelContainer={refState}
            avatar={presenter.avatar}
            ref={onCallStartRef}
            onChangeAudioMuted={presenter.onChangeAudioMuted}
            onChangeVideoMuted={presenter.onChangeVideoMuted}
            onChangeInitialDevicesIds={presenter.onChangeInitialDevicesIds}
            initialMedia={initialMedia}
          />
          <StartCall
            isMediaLoading={!presenter.hasMediaPermissions}
            waitingRoomMemberStatus={presenter.waitingRoomMemberStatus}
            onStart={presenter.onStart}
            onClose={presenter.onClose}
          />
        </div>
      </RoomCallPopupContent>
      <div
        className={styles.backgroundContainer}
        ref={backgroundPanelRef}
      />
    </>
  );
});
